// extracted by mini-css-extract-plugin
module.exports = {"tabLayoutRight":"styles_tabLayoutRight__3jSH0","wrapLayout":"styles_wrapLayout__12Fd9","title":"styles_title__8KTJn"};